import { AudioObject } from '@hendrx/icons/AudioObject';

import { WidgetType } from 'shared/common/utils/widgetsUtils';
import { ManifestType } from 'shared/types/ManifestType';

import { createNewAudioData } from './create';
import { manifestLocales } from './manifest.locales';
import AudioPreviewImageRtl from './resources/audio-rtl.svg';
import AudioPreviewImage from './resources/audio.svg';

export const Manifest: ManifestType = {
  name: WidgetType.Audio,
  previewGroups: [
    {
      id: 'audio',
      divider: {
        icon: AudioObject,
        title: 'audio'
      },
      previews: [
        {
          name: 'audioPreview',
          previewImage: {
            // Rendered as an `<img>`, so CSS cannot mirror it — RTL gets its own asset.
            paths: {
              en: AudioPreviewImage,
              he: AudioPreviewImageRtl,
              ar: AudioPreviewImageRtl
            },
            size: {
              width: 285,
              height: 140
            },
            alt: { ...manifestLocales.audio.previewImageAlt }
          },
          dimensions: {
            width: 75,
            height: 75
          },
          initializeProps: () => createNewAudioData()
        }
      ]
    }
  ],
  additionalData: {
    maxFileSizeBytes: 3_072_000,
    acceptFileType: ['audio/x-wav', 'audio/mpeg', 'audio/x-ms-wma'],
    maxFiles: 1,
    constraints: {
      minHeight: 75,
      minWidth: 75
    },
    isResizableVertically: true,
    shouldKeepAspectRatio: true
  }
};
